import useSWR from "swr";

import { type McpTokenStatusResponse, mcpTokenEndpoint } from "@/api/client";
import { API_BASE_URL } from "@/lib/env";

export function useMcpToken(enabled = true) {
  const { data, error, isLoading, mutate } = useSWR<McpTokenStatusResponse>(
    enabled ? mcpTokenEndpoint(API_BASE_URL) : null,
  );

  return {
    mcpTokenStatus: data ?? null,
    isLoading: enabled && isLoading,
    isError: Boolean(error),
    refreshMcpToken: mutate,
  };
}
